

    <div class="row">
      <div class="col-md-12">       
          <div class="table-responsive">
            <table *ngFor="let item of Items; let i = index"                     
                id="{{defaultTableName + '-' + i}}"  class="table table-hover table-condensed fixed-header" [ngClass]="{'table-sm': Condensed, 'table-column-border-odd': Config.ColumnBorderOdd, 'table-column-border-even': Config.ColumnBorderEven }" #table
                >
              <thead *ngIf="Config.ShowHeader == null || Config.ShowHeader == true" class="thead-light" #thead>
                <tr *ngIf="i == 0">
                  <th *ngIf="Config.ShowCheckBoxes" style="width:20px;"></th>
                  <th *ngFor="let column of TableColumns" 
                      [ngStyle]="{'width': column.Width ? column.Width : 'auto',
                                  'text-align': column.Aligment ? column.Aligment : 'left'}"
                                  >
                      <span>{{column.Label | translate}}</span>
                      
                  </th>
                </tr>               
              </thead>
              <tbody #tbody>
                <!-- <tr class="table-loader" [ngClass]="{'collapsed': !ShowLoader}" *ngIf="true">
                  <td>
                    <div class="loader" [ngClass]="{'collapsed': !ShowLoader}">
                      <div class="icon">
                        <span class="fa fa-spinner fa-spin"></span>
                      </div>
                      <div class="text">
                        <span>Molim, sačekajte</span>
                      </div>
                    </div>
                  </td>
                </tr> -->
                <tr rowColor [rowColorItem]="item" [rowColors]="RowColors">
                  <td *ngIf="Config.ShowCheckBoxes" style="width:20px">
                    <input type="checkbox" [(ngModel)]="item.Checked" (change)="CheckItem(item)">
                  </td>
                  <td [ngStyle]="{'text-align': column.Aligment ? column.Aligment : 'left', 'width': column.Width}"
                    *ngFor="let column of TableColumns " >
                      <span *ngIf="column.Type != 'color-box'" [innerHtml]=" {item: item, column: column } | getPropertyValue "></span>
                      <span *ngIf="column.Type == 'color-box'" class="color-box" [ngStyle]="{'background-color': item[column.Name]}" ngbTooltip="{{ item[column.TooltipName] | translate }}" container="body"></span>
                  </td>  

                </tr>
                <tr *ngIf="item && item.Checked">
                  <td class="pl-4">
                    <table class="table-condensed table-sm" border="0" bordercolor="#9F9EBF" style="font-size: 0.9em;" #table2>
                      <thead #thead2>
                        <th *ngFor="let column2 of Table2Columns"
                            [ngStyle]="{'width': column2.Width ? column2.Width : 'auto',
                            'text-align': column2.Aligment ? column2.Aligment : 'left'}"
                            style="background-color: #CBCADC; border-color: #9F9EBF;"
                            [ngClass]="{'text-right': column2.Type == 'number'}">
                            <span>{{column2.Label | translate}}</span>
                        </th>
                      </thead>
                      <tbody #tbody2>
                        <tr *ngFor="let item2 of item.Details; let i = index"                    
                          >
                          <td [ngStyle]="{'text-align': column2.Aligment ? column2.Aligment : 'left', 'width': column2.Width}"
                            *ngFor="let column2 of Table2Columns" 
                            [ngClass]="{'text-right': column2.Type == 'number'}">
                              <span *ngIf="column2.Type != 'color-box' && !column2.Required" [innerHtml]=" {item2: item2, column2: column2 } | getPropertyValue "></span>
                              <span *ngIf="column2.Type == 'color-box'" class="color-box" [ngStyle]="{'background-color': item2[column2.Name]}" ngbTooltip="{{ item2[column2.TooltipName] | translate }}" container="body"></span>
                              
                              <yt-number-input-v4 
                                #numberInputV3                                
                                *ngIf="column2.Type == 'number' && column2.Required"  
                                name="column2.Name" 
                                [Label]="''"
                                [FormatString]="column2.Format" 
                                [(ngModel)]="item2[column2.FormControlName]"
                                >
                              </yt-number-input-v4>
                            
                            </td> 
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
      </div>
    </div>

 